import React from 'react';
import PropTypes from 'prop-types';

import { WHITE, GOLDEN_ROD } from '@constant/colors';

const Plus = ({ color, backgroundColor }) => (
  <svg className="transfer__option-plus" viewBox="0 1 32 13">
    <rect
      width="32"
      height="13"
      y="1"
      fill={backgroundColor}
      fillRule="evenodd"
      rx="6.5"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M5.648 10H6.72V8.2h1.296c1.312 0 2.04-.8 2.04-1.888 0-1.072-.728-1.816-2.04-1.816H5.648V10zM7.92 5.36c.696 0 1.048.392 1.048.968 0 .584-.352 1.008-1.048 1.008h-1.2V5.36h1.2zM11.048 10h3.704v-.904H12.12v-4.6h-1.072V10zm4.384-2.208c0 1.712.984 2.304 2.376 2.304s2.368-.592 2.368-2.304V4.496h-1.08v3.28c0 .896-.424 1.4-1.288 1.4-.872 0-1.296-.504-1.296-1.4v-3.28h-1.08v3.296zm5.64.64c0 1.024.784 1.664 2.232 1.664 1.48 0 2.312-.704 2.312-1.736 0-1.152-.928-1.424-1.808-1.584l-.368-.064c-.656-.112-1.208-.248-1.208-.76 0-.496.472-.752 1.088-.752.616 0 1.072.28 1.072.784h1.048c0-.968-.832-1.584-2.12-1.584-1.32 0-2.16.712-2.16 1.656 0 1.192.992 1.44 1.896 1.592l.368.064c.6.112 1.096.264 1.096.752 0 .528-.448.832-1.216.832-.712 0-1.184-.336-1.184-.864h-1.048z"
    />
  </svg>
);

Plus.propTypes = {
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
};

Plus.defaultProps = {
  color: WHITE,
  backgroundColor: GOLDEN_ROD,
};

export default Plus;
